import { connect } from 'react-redux'
import { compose } from 'recompose'
import { closeLoans } from '../../../../actions/homeowner'

const MortgagesContainer = compose(
  connect(null, dispatch => ({
    closeLoans: () => dispatch(closeLoans()),
  }))
)

export default MortgagesContainer
